/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const RestoreDatabaseResponse = core.serialization.object({
    host: core.serialization.string(),
    port: core.serialization.number(),
    dbname: core.serialization.string(),
});
